module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Sensory Adventures","short_name":"Sensory Adventures","description":"Sensory Adventures.","background_color":"#ffffff","theme_color":"#614dff","display":"standalone","icon":"/Users/pancod/Developer/gatsby.sensoryadventures/src/images/logo_sensory_adventures.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"737cff6326a8b07a3032892a224feafb"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
